import { FormattedMessage } from "react-intl"
import React from "react"

export const renderConfigurationLabel = (label: string) => {
    switch (label) {
    case "billingAddressFieldId":
        return <FormattedMessage
            id="integration.form.pipedrive_form_component.billing_address_field_id"
            defaultMessage="Billing Address Field"
        />
    case "shippingAddressFieldId":
        return <FormattedMessage
            id="integration.form.pipedrive_form_component.shipping_address_field_id"
            defaultMessage="Shipping Address Field"
        />
    case "organizationBillingAddressFieldId":
        return <FormattedMessage
            id="integration.form.pipedrive_form_component.organization_billing_address_field_id"
            defaultMessage="Organization Billing Address Field"
        />
    case "organizationShippingAddressFieldId":
        return <FormattedMessage
            id="integration.form.pipedrive_form_component.organization_shipping_address_field_id"
            defaultMessage="Organization Shipping Address Field"
        />
    default:
        return label
    }
}


// WEBPACK FOOTER //
// ./src/utils/integration/pipedrive/utils.tsx